import React, { useState} from "react";
import imgLog3 from '../../imgs_steps/IMG_003.png';
import { Family} from "../../pageInside/Rolle"
import Modal from 'react-bootstrap/Modal';
import Pages from '.'

var fileAdding ={
    title:'',
    error:''   
}
const emailDataHtml = (jsonInput, htmlTemplate)=>{

    const checkIfFunction = (f)=>{
        return typeof f === 'object' ? true : false
      }

      const replaceObj = (array, obj,  key, arrayRepl)=>{
        let linkData
        let data
        for (let i = 0; i < array.length; i++) {
            linkData = "${"+ key +"." + array[i] + "}"
            data = obj[key][array[i]]
            arrayRepl.push([linkData, data])
        }  
    }

    const secondaireData = (prObj, seObj, key, arrayRepl)=>{
        let newArray
        let linkData
        let data 
        
        if(checkIfFunction(seObj)){
        newArray =  Object.keys(seObj ? seObj:{});
         replaceObj(newArray, prObj, key, arrayRepl)
        }else{
            linkData = "${"+ key +"}"
            data = prObj[key] 
            arrayRepl.push([linkData, data])
        }
      }

      const htmlReplaceData = (obj)=>{
        let arrayRepl = []
       let primaireData = Object.keys(obj ? obj:{});
       primaireData.forEach((da => secondaireData(obj, obj[da], da, arrayRepl)))
       return arrayRepl
    }
    const handleRunCode = () => {
        try {
          // Parse le JSON entré par l'utilisateur
          const data = JSON.parse(jsonInput);

          
          // Remplacer les placeholders dans le HTML avec les valeurs du JSON
         let dynamicHtml = htmlTemplate
         
            let arrayReplace = htmlReplaceData(data)
            for (let i = 0; i < arrayReplace.length; i++) {
                let name = arrayReplace[i][1]
                let linkName  = arrayReplace[i][0]
               dynamicHtml = dynamicHtml.replace(linkName, name) 
            }
          // Utilisation du HTML combiné et affichage du contenu dans un iframe
         return dynamicHtml;
        } catch (error) {
          console.error('Invalid JSON:', error);
        }
      };

return handleRunCode()

}

const isObjectValid = (obj) => {
    if (obj === null || obj === undefined ) return false;
  
    if (typeof obj === 'object' && !Array.isArray(obj)) {
      for (const key in obj) {
        if (!isObjectValid(obj[key])) return false;
      }
      return true;
    }
  
    if (Array.isArray(obj)) {
      return obj.every(item => isObjectValid(item));
    }
  
    // Vérifie les valeurs finales (string, number, etc.)
    return obj !== null && obj !== '' && obj !== undefined;
  };


const FormPageDataMail = (props) => {

    const { 
        laguangeElakay,
        infoSource,
        editAddByJson= false,
        getDataEmail,
        editAdd, 
        setEditAdd,
        nameObj,
        paragra,
        setParagra,
        ObjetPage,
        edit_add,
        token,
        Alllanguage,
        AlllanguageSelect,
        languageUsertra,
        languageTradictor,
        updateLanguageElakay0,
        deleteLanguageElakay0,
        updateLanguageFileUp,
        buttonAddLanguage
    }= props

    const [getNewDataEmail, setNewDataEmail] = useState({});
    const [checkdeletePara, setCheckDeletePara] = useState(false);
    const [error, setError] = useState('')
    const [deletePara, setDeletePara] = useState(false);
    const [showEmailPage, setShowEmailPage] = useState(false);
     const [htmlTemplate, setHtmlTemplate] = useState('<!-- enter your HTML Et CSS template here...-->');
    const [priObj, setPriObj]= useState({})
    const [objet, setObejet] = useState({})

    const inputOK = (a, b, c)=>{
        if(c == undefined){
            return  {v : b,  s: 'form-control'}
        }else  if(c == {}){
          return {v :"",  s: 'form-control is-invalid'}
      }else if(checkUndefName(c, a)){
          return {v : c[a],  s: "form-control is-valid" }
        }else{
          return {v :"",  s: 'form-control is-invalid'}
        }
      
      }

      const buttonAdd =()=>{
        let data = objet
            
        updateLanguageElakay0(languageTradictor._id, token, {[nameObj]: {_id: getNewDataEmail._id, data}}, Family()).then(data => {
            if (data.error) {
               console.log(data.error)
            } else {
                setNewDataEmail({})
                setObejet({})
                setPriObj({})
                AlllanguageSelect()
                languageUsertra()
                // setEditAdd(true)
                // setParagra(ObjetPage)    
        }
        })
    }

    const buttonDelPara =()=>{
        deleteLanguageElakay0(languageTradictor._id, getNewDataEmail._id, nameObj, token).then(data => {
            if (data.error) {
               setError(data.error)
            } else {
                setNewDataEmail({})
                setObejet({})
                setPriObj({})
                setCheckDeletePara(false)
                setDeletePara(false)
                setEditAdd(true)
                AlllanguageSelect()
                languageUsertra()
                
        }
        })
    }
    const deleteAgree = () => {
         
        return (
            <div className="contaire">
                <div className="row justify-content-center " >
                    <Modal
                        show={deletePara}
                        size="lg"
                        onHide={() => setDeletePara(false)}
                        dialogClassName="modal-90w"
                        aria-labelledby="example-custom-modal-styling-title"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="example-custom-modal-styling-title">
                                <h4 className="text-center">
                                    {/* delete this items */}
                                    {infoSource.language(infoSource, "title", "delThtems")}
                                    </h4>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row justify-content-center m-4">
     
                            <div className="list-unstyled">
                                <input
                                    onChange={() => setCheckDeletePara(!checkdeletePara)}
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={checkdeletePara  ? 'checked' : ''}
                                    id="chButAgree"
                                />
                                <label className="form-check-label" for="chButAgree">
                                    {/* check the button if your are agree */}
                                    {infoSource.language(infoSource, "title", "chButAgree")}
                                    </label>
                                    
                            </div>
                              
                                  {
                                  getNewDataEmail && getNewDataEmail._id != undefined && checkdeletePara ?
                                   <button onClick={() => buttonDelPara()} className="btn btn-primary float-right">Delete this param </button>
                                   :
                                   <button className="btn btn-primary float-right" disabled>Delete this param </button>
                                }
                          
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
    
        )
    }

    const allSetData = (obj)=>{

        setNewDataEmail(obj)
     setObejet(obj?.data || {})
    }
    const selTraDataMail =(title)=>{
        languageTradictor[nameObj].filter(obj => obj.data.title == title &&  allSetData(obj))
        getDataEmail.filter(obj => obj.data.title == title &&   setHtmlTemplate(obj))
    }

    const TraDataMailBool =(array = [], title)=>{
        return array.filter(obj => obj.data.title  == title)[0] ? true : false
     }

     const getIndexByTitle = (array, title) => {
        return array && array.findIndex(item => item.data.title != 'about us' && item?.data?.title === title);
      };

    const handleTilteData = () => event => {
        setNewDataEmail({})
        setObejet({})
        setPriObj({})
        const title = event.target.value; 
        const value = title && getIndexByTitle(getDataEmail, title);
        setPriObj(getDataEmail[value]?.data || {})
        // TraDataMailBool(getDataEmail[value].data.title)
       value ? 
                    TraDataMailBool(languageTradictor[nameObj], getDataEmail[value].data.title)? 
                                selTraDataMail(getDataEmail[value].data.title) 
                                            : setObejet(getDataEmail[value].data) 
                         :  allSetData({})
    //    value != 0 && selTraDataMail(getDataEmail[value].data.title)
    };

    const handleChange = name => event => {
        const value = event.target.value;
        let pname = name[0]
        let sname = name[1]
    
        if(name.length == 2){
            setObejet({ ...priObj, [pname] : {...priObj[pname], [sname]: value}});
        
        }else{
            setObejet({ ...priObj, [pname]: value});
        }
    
    };
    const checkIfFunction = (f)=>{
        return typeof f === 'object' ? true : false
      }

const selectObArData =()=>{
    return <div className="form-group">
          <label className="text-muted">
            {/* select languages and compare */}
            <h3>{getNewDataEmail && getNewDataEmail._id == undefined? "add " + priObj.title: "edit " + priObj.title }</h3>data title for edit 
            </label>
           
           <select onChange={handleTilteData()} className="form-control" value={priObj && priObj.title  != undefined ? priObj.title : ''} >
           <option value={''} > select data title</option>
           {getDataEmail && getDataEmail.map((ob, j) =>{
                return ob.data.title != 'about us' && <option value={ob.data.title} >{ob.data.title}</option>
               })}
           </select>
       </div>

}

const checkUndefName = (a, b)=>{
    let aa  = a && Object.keys(a)
    return  a && aa.includes(b)
   } 

   const selNewName = (a, b)=>{
    return a? a : b
}

const deepGet = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };
    const formInput1 = (a ,b, i, akey, c)=> {
        let inpClass = c == undefined ? "form-control" : checkUndefName(c, a) ? "form-control is-valid" : 'form-control is-invalid'
        return <div key = {i} className="form-group">
         <label className="text-muted">{a}</label>
         {b.length > 90 ?
         <textarea onChange={handleChange([akey, a])}  type="text" className={inpClass} placeholder={selNewName(objet[a], b)} value={selNewName(deepGet(objet, `${akey}.${a}`), '')} rows="4"/>
         :
             <input onChange={handleChange([akey, a])}  type="text" className={inpClass} placeholder={selNewName(objet[a], b)} value={selNewName(deepGet(objet, `${akey}.${a}`), '')} />
            }
         </div>

    }

    const formInput0 = (a ,b, i, c)=>{
        let oe1 = Object.entries(b)
         let inpClass = c == undefined ? "form-control" : checkUndefName(c, a) ? "form-control is-valid" : 'form-control is-invalid'
       return a != "title" && <div key={i} className="p-3">
             <label className="text-muted">{checkIfFunction(b)? <h4>{a}</h4> : a }</label>
             {checkIfFunction(b)?
             <div style={{ border: "1px solid WhiteSmoke" }} className="p-3"> 
            { oe1.map(([key, val], i) => { return formInput1(key, val, i, a)})}
             </div>
             :
           <div key = {i} className="form-group p-3">
                {b.length > 90 ?
                 <textarea onChange={handleChange([a])}  type="text" className={inpClass} placeholder={selNewName(objet[a], b)} value={selNewName(objet[a], '')} rows="4"/>
                    :
                <input onChange={handleChange([a])}  type="text" className={inpClass} placeholder={selNewName(objet[a], b)} value={selNewName(objet[a], '')} />
                }
            </div>
            }
        </div>
    }

    const ArrayFormInput = ()=>{
        let oe = priObj && Object.entries(priObj)

       return <div>
                {priObj && oe.map(([key, val], i) => { return formInput0(key, val, i)})}
                <div className="row justify-content-center">
                <div className="col col-sm-12">

                {(isObjectValid(objet) && Object.keys(objet).length !== 0) ?
                <button  className="btn btn-primary float-right pb-2 rounded-4" onClick={()=>buttonAdd()}>save</button>
                :
                <button  className="btn btn-primary float-right pb-2 rounded-4 disabled">save</button> 
                }
            </div> </div> 
            </div> 
    }
let email_Actiivation = emailDataHtml(JSON.stringify(getNewDataEmail.data, null, 2), htmlTemplate.htmlTemplate)
 

    const printListeShop = () => (
    
        <Modal
            size="xl"
            show={showEmailPage}
            onHide={() =>  setShowEmailPage(false)}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
        >
              <Modal.Header closeButton>
                        
                        </Modal.Header>
            <Modal.Body>
            <div> 
                <iframe
                // srcDoc={generateEmailTemplate1(user, emailToken)}
                srcDoc={email_Actiivation}
                title="Result"
                sandbox="allow-scripts"
                style={{  backgroundColor: '#FFFFFF', width: '100%', minHeight: '1000px', border: '1px solid #ddd' }}
              />
            </div>
            </Modal.Body>
        </Modal>

)

    return (<>

    {(selectObArData())}
    <div className="row justify-content-center">
    <div className="col col-sm-12"> 
    {getNewDataEmail && getNewDataEmail._id != undefined && <button  className="btn btn-primary float-left pt-2 pb-2 pr-2 pl-2 rounded-4" onClick={()=>setShowEmailPage(true)}>view e-mail</button>}
        {getNewDataEmail && getNewDataEmail._id != undefined &&  <button onClick={() => setDeletePara(true)} className="btn btn-primary pt-2 pb-2 pr-2 pl-2 float-right rounded-4">Delete e-mail</button>} 
    </div>
    </div>
       {ArrayFormInput()}
       {deleteAgree()}
      {printListeShop()}
            </>)

}

export default  FormPageDataMail